import propTypes from "prop-types"
import { useEffect, useCallback } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useDownloadTemplate } from "hooks/use-download-template"

import { useMutation } from "@tanstack/react-query"

import { ImportForm } from "components"
import { masiveImportCustomers } from "services/customers"

const ImportModalForm = ({ isOpen, toggle, setShowAlertSuccess, setMsgSuccess }) => {
  const { data, error, isError, isLoading, isSuccess, mutateAsync } = useMutation(masiveImportCustomers)
  const getStatusLabel = (status) => {
    if (status === "pending") return "En cola"
    if (status === "processing") return "Procesando"
    if (status === "success") return "Completado"
    if (status === "failed") return "Fallido"

    return status
  }
  const downloadTemplate = useCallback(() => {
    useDownloadTemplate("/customers/download_template")
  }, [])

  const submit = async (data) => {
    await mutateAsync(data)
  }

  useEffect(() => {
    if (isSuccess) {
      setMsgSuccess(
        `La importación de clientes fue enviada a Celery y ya se está procesando.<br/><br/>
        Estado actual: ${getStatusLabel(data?.status)}<br/>
        <a href="/logs-importation/${data?.id}">Ver más</a>
        `
      )
      setShowAlertSuccess(true)
      toggle()
    }
  }, [isSuccess])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Importar Clientes
      </ModalHeader>
      <ModalBody>
        <div>
          <ImportForm
            submit={submit}
            isError={isError}
            error={error}
            isLoading={isLoading}
            toggle={toggle}
            downloadTemplate={downloadTemplate}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

ImportModalForm.propTypes = {
  isOpen: propTypes.bool.isRequired,
  toggle: propTypes.func.isRequired,
  setShowAlertSuccess: propTypes.func.isRequired,
  setMsgSuccess: propTypes.func.isRequired,
}

export default ImportModalForm
